// extracted by mini-css-extract-plugin
module.exports = {"input":"UploadButton_input__3fvaX","icon":"UploadButton_icon__1KxLN","label":"UploadButton_label__3ijGE"};